<template>
  <div class="features-list">
    <div
      class="row mb-2"
      v-for="scope in scopes"
      v-if="ignored_scopes.indexOf(scope) == -1"
      :class="scope_headers.indexOf(scope) > -1 ? 'mt-4 header' : ''"
    >
      <div class="col-md-6">
        <div class="item">{{ scope | t }}</div>
      </div>
      <div class="col-md-6">
        <input
          type="checkbox"
          :disabled="is_feature_readonly(scope)"
          :checked="isFeatureAvailable(scope)"
          @change="changeFeatureInclusion(scope)"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    scopes: {
      type: Array
    },
    value: {
      type: Array
    },
    plan: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    is_editing_non_custom_plan: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      scope_headers: [
        'order_management',
        'shipment_management',
        'return_management',
        'cost_management',
        'basic_account_management'
      ],
      ignored_scopes: ['support_access']
    };
  },
  methods: {
    changeFeatureInclusion(feature) {
      if (this.disabled) {
        return;
      }

      let featureIndex = this.value.findIndex((feat) => feat === feature);

      if (featureIndex >= 0) {
        this.$emit('input', _.without(this.value, feature));
      } else {
        this.$emit('input', _.concat(this.value, [feature]));
      }
    },
    isFeatureAvailable(feature) {
      return this.value.includes(feature);
    },
    is_feature_readonly(feature) {
      if (this.disabled) {
        return true;
      }

      if (this.is_editing_non_custom_plan === false) {
        return false;
      }

      return this.initial_scopes.includes(feature);
    }
  },
  computed: {
    initial_scopes() {
      if (!this.plan) {
        return [];
      }

      if (!this.plan.feature_scopes) {
        return [];
      }

      return this.plan.feature_scopes.split(' ');
    }
  }
};
</script>

<style scoped>
.features-list .header .item {
  font-weight: bold;
}
</style>
